<footer class="footer" id="footer">
  <div class="footer-wrap">
    <div class="footer-brand">
      <a routerLink="/home">
        <img id="logo-img" src="assets/images/brand/worldtumbler-on-dark.svg" alt="WorldTumbler" />
      </a>
    </div>

    <nav class="footer-nav" aria-label="Footer">
      <a routerLink="/learn-more/true">About</a>
      <a routerLink="/terms-of-service">Terms of Service</a>
      <a routerLink="/privacy-policy">Privacy and Cookies</a>
      <a routerLink="/FAQ">FAQ</a>
    </nav>

    <div class="footer-meta">
      <div class="socialmedia">
        <a href="https://web.facebook.com/worldtumbler.1/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <img src="assets/icons/icon-facebook.svg" alt="" />
        </a>
        <a href="https://discord.com/invite/kBBF3NKZCT" target="_blank" rel="noopener noreferrer" aria-label="Discord">
          <img src="assets/icons/discord-icon.svg" alt="" class="icon-footer" />
        </a>
        <a href="https://www.reddit.com/r/WorldTumbler/" target="_blank" rel="noopener noreferrer" aria-label="Reddit">
          <img src="assets/icons/reddit-icon.svg" alt="" class="icon-footer" />
        </a>
      </div>
      <p class="copyright-text">© 2026 Dovetail Ventures LLC</p>
    </div>
  </div>
</footer>
